import { render, staticRenderFns } from "./PopupImage.vue?vue&type=template&id=67624603"
import script from "./PopupImage.vue?vue&type=script&lang=js"
export * from "./PopupImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports